<dashboardnav>

  <cradua-country
  [continents]="continents$ | async"
  [countries]="countries$ | async"

  (changeEmit)="onSubmitCountry($event)"
  (deleteEvent)="onDeleteCountry($event)"
  *ngIf="
  !(isLoadingContinent$ | async ) &&
  !(isLoadingCountry$ | async )
  "
  >
</cradua-country>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingContinent$ | async ) ||
  (isLoadingCountry$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
